import { ASAAS_DOCS } from "./constants"

/**
 * Default class for Asaas exceptions and errors.
 *
 * It can be serialized to JSON through the `toJSON` method.
 */
export class AsaasError extends Error {
  constructor(message: string) {
    super(
      `Asaas Error: ${message}\n\nPlease, refer to the documentation at: ${ASAAS_DOCS}`
    )
    this.name = "AsaasError"
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
    }
  }
}

export const ApiErrors = {
  401: {
    code: "unauthorized",
    description: "Unauthorized request",
  },
  403: {
    code: "forbidden",
    description: "Forbidden request",
  },
  404: {
    code: "not_found",
    description: "Resource not found",
  },
}

export type AsaasApiError = {
  errors: {
    code: string
    description: string
  }[]
}
